import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SignaturePad from "react-signature-canvas";
import { toast } from "react-toastify";
import styleTattoo from "../../styles/tattoo.module.css";

const ContratoTattooExtendido = () => {
   const navigate = useNavigate();
   const location = useLocation();
   const { state } = location;
   const token = localStorage.getItem("token");
   const urlContrato = process.env.REACT_APP_URL_DIR + "contratotattoo/ext";
   
   const [firmaClientePreview, setFirmaClientePreview] = useState(null);
   const clienteSignaturePadRef = useRef();
   const [firmaTutorPreview, setFirmaTutorPreview] = useState(null); // ✅ Nuevo
   const tutorSignaturePadRef = useRef(); // ✅ Nuevo

   const [input, setInput] = useState({
      // Datos Personales
      nombre_autopercibido: "nada",
      pronombres: "ella",
      otro_pronombre: "",
      fechaHoy: new Date().toISOString().split("T")[0],
      fecha_nacimiento: "",
      fechaTurno: "",
      apellido: "",
      dni: "",
      telefono: "",
      telefono_familiar: "",
      edad: "",

      // Antecedentes
      antecedentes_melanoma: "No",
      afecciones: [],
      afecciones_zona: [],
      lunares_zona: "No",
      alergia_latex: "No",
      tratamientoFarmacos: [],
      quimioterapiaReciente: "No",
      quimioterapiaProxima: "No",
      trasplanteOrganos: "No",
      valvulaCardiaca: "No",
      operacionReciente: "No",
      infeccionActual: "No",
      alergiaParticular: "No",
      alergiaLidocaina: "No",
      embarazo: "No",
      lactancia: "No",

      // Campos adicionales
      otra_afeccion: "",
      otra_afeccion_zona: "",
      otro_farmaco: "",
      aclaracionAlergia: "",
      aclaracionesGenerales: "",

      // Aceptaciones
      comprendoInmunosupresion: false,
      aceptoAlcoholEstupefacientes: false,
      comprendoInfecciones: false,
      acepto_alergia: false,
      acepto_apto: false,

      // Firma
      firma_digital_cliente: "",
      fecha: new Date().toISOString().split("T")[0],
      firmado: false,

      // IDs relacionales
      clienteId: state?.clienteId || 0,
      presupuestoId: state?.presupuestoId || 0,
   });

   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   useEffect(() => {
      // Si viene un id en el state y es distinto de 0, buscar los datos
      if (location.state && location.state.id && location.state.id !== 0) {
         fetch(process.env.REACT_APP_URL_DIR + "contratotattoo/ext/" + location.state.id)
            .then((res) => res.json())
            .then((data) => {
               console.log("useEffect data: ", data);
               if (data) {
                  // Carga el primer registro por defecto
                  loadRecord(data);
               }
            });
      }
   }, []);

   const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setInput((prev) => ({
         ...prev,
         [name]: type === "checkbox" ? checked : value,
      }));

      if (errors[name]) {
         setErrors((prev) => ({
            ...prev,
            [name]: "",
         }));
      }
   };

   const handleMultiSelect = (name, value) => {
      setInput((prev) => {
         const currentValues = prev[name] || [];
         const newValues = currentValues.includes(value)
            ? currentValues.filter((v) => v !== value)
            : [...currentValues, value];
         return {
            ...prev,
            [name]: newValues,
         };
      });
   };
   
   function loadRecord(record) {
      console.log("Cargando registro: ", record);

      // Función helper para formatear fechas
      const formatDate = (dateString) => {
         if (!dateString) return "";
         return dateString.split("T")[0];
      };

      setInput({
         // Datos Personales
         nombre_autopercibido: record.nombre_autopercibido || "nada",
         pronombres: record.pronombres || "ella",
         otro_pronombre: record.otro_pronombre || "",
         fechaHoy: formatDate(record.fechaHoy) || new Date().toISOString().split("T")[0],
         fechaTurno: formatDate(record.fecha_turno) || "",
         apellido: record.apellido || "",
         dni: record.dni || "",
         telefono: record.telefono || "",
         telefono_familiar: record.telefono_familiar || "",
         edad: record.edad || "",
         fecha_nacimiento: formatDate(record.fecha_nacimiento) || "",

         // Antecedentes
         antecedentes_melanoma: record.antecedentes_melanoma || "No",
         afecciones: record.afecciones || [],
         afecciones_zona: record.afecciones_zona || [],
         lunares_zona: record.lunares_zona || "No",
         alergia_latex: record.alergia_latex || "No",
         tratamientoFarmacos: record.tratamiento_farmacos || [],
         quimioterapiaReciente: record.quimioterapia_reciente || "No",
         quimioterapiaProxima: record.quimioterapia_proxima || "No",
         trasplanteOrganos: record.trasplante_organos || "No",
         valvulaCardiaca: record.valvula_cardiaca || "No",
         operacionReciente: record.operacion_reciente || "No",
         infeccionActual: record.infeccion_actual || "No",
         alergiaParticular: record.alergia_particular || "No",
         alergiaLidocaina: record.alergia_lidocaina || "No",
         embarazo: record.embarazo || "No",
         lactancia: record.lactancia || "No",

         // Campos adicionales
         otra_afeccion: record.otra_afeccion || "",
         otra_afeccion_zona: record.otra_afeccion_zona || "",
         otro_farmaco: record.otro_farmaco || "",
         aclaracionAlergia: record.aclaracion_alergia || "",
         aclaracionesGenerales: record.aclaraciones_generales || "",

         // Aceptaciones
         comprendoInmunosupresion: record.comprendo_inmunosupresion || false,
         aceptoAlcoholEstupefacientes: record.acepto_alcohol_estupefacientes || false,
         comprendoInfecciones: record.comprendo_infecciones || false,
         acepto_alergia: record.acepto_alergia || false,
         acepto_apto: record.acepto_apto || false,

         // Firma
         firma_digital_cliente: record.firma_digital_cliente || "",
         fecha: record.fecha || new Date().toISOString().split("T")[0],
         firmado: record.firmado || false,

         // Tutor (para menores de 18)
         nombreTutor: record.nombreTutor || "",
         firma_digital_tutor: record.firma_digital_tutor || "",

         // IDs relacionales
         clienteId: record.clienteId || 0,
         presupuestoId: record.presupuestoId || 0,
      });

      setFirmaClientePreview(record.firma_digital_cliente || null);
      setFirmaTutorPreview(record.firma_digital_tutor || null);
   }

   const validateForm = () => {
      const newErrors = {};

      // Validar campos obligatorios
      // if (!input.nombre_autopercibido.trim())
      //    newErrors.nombre_autopercibido = "Nombre autopercibido es requerido";
      if (!input.apellido.trim())
         newErrors.apellido = "Apellido es requerido";
      if (!input.dni.trim()) newErrors.dni = "DNI es requerido";
      if (!input.telefono.trim())
         newErrors.telefono = "Teléfono es requerido";
      if (!input.telefono_familiar.trim())
         newErrors.telefono_familiar = "Teléfono familiar es requerido";
      if (!input.edad) newErrors.edad = "Edad es requerida";
      if (!input.fechaTurno)
         newErrors.fechaTurno = "Fecha del turno es requerida";

      // Validar aceptaciones obligatorias
      if (!input.comprendoInmunosupresion)
         newErrors.comprendoInmunosupresion =
            "Debe aceptar esta condición";
      if (!input.aceptoAlcoholEstupefacientes)
         newErrors.aceptoAlcoholEstupefacientes =
            "Debe aceptar esta condición";
      if (!input.comprendoInfecciones)
         newErrors.comprendoInfecciones = "Debe aceptar esta condición";
      if (!input.acepto_alergia)
         newErrors.acepto_alergia = "Debe aceptar esta condición";
      if (!input.acepto_apto)
         newErrors.acepto_apto = "Debe aceptar esta condición";

      if (!input.firmado) {
         newErrors.firmado = "Debe firmar el documento";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
   };

   const handleSubmit = async (e) => {
      e.preventDefault();

      if (!validateForm()) {
         toast.error("Por favor complete todos los campos obligatorios");
         return;
      }

      const firmaBase64C = clienteSignaturePadRef?.current
         ?.getCanvas()
         ?.toDataURL("image/png");

      setIsSubmitting(true);

      try {
         const dataToSend = {
            ...input,
            firma_digital_cliente: firmaBase64C || null,
         };
         
         console.log('dataToSend: ', dataToSend);
         const response = await fetch(urlContrato, {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToSend),
         });

         if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
         }

         const result = await response.json();
         console.log("Contrato guardado:", result);

         toast.success("Consentimiento informado guardado exitosamente!");
         navigate("/contratot");
      } catch (error) {
         console.error("Error al guardar contrato:", error);
         toast.error(
            "Error al guardar el consentimiento. Por favor, intente nuevamente."
         );
      } finally {
         setIsSubmitting(false);
      }
   };
   const calcularEdad = (fechaNacimiento) => {
      if (!fechaNacimiento) return "";

      const hoy = new Date();
      const nacimiento = new Date(fechaNacimiento);
      let edad = hoy.getFullYear() - nacimiento.getFullYear();
      const mes = hoy.getMonth() - nacimiento.getMonth();

      if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
         edad--;
      }

      return edad.toString();
   };

   const handleFechaNacimientoChange = (e) => {
      const fecha = e.target.value;
      const edad = calcularEdad(fecha);

      setInput((prev) => ({
         ...prev,
         fecha_nacimiento: fecha,
         edad: edad,
      }));
   };
   return (
      <div className={styleTattoo.container}>
         <div className={styleTattoo.formContainer}>
            <h1 className={styleTattoo.title}>CONSENTIMIENTO INFORMADO</h1>

            <form onSubmit={handleSubmit}>
               {/* DATOS PERSONALES */}
               <section className={styleTattoo.section}>
                  <h2 className={styleTattoo.sectionTitle}>
                     DATOS PERSONALES
                  </h2>

                  {/* <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        Nombre autopercibido *
                        <input
                           type="text"
                           name="nombre_autopercibido"
                           value={input.nombre_autopercibido}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.nombre_autopercibido
                                 ? styleTattoo.inputError
                                 : ""
                           }`}
                           placeholder="Ingrese nombre autopercibido"
                        />
                        {errors.nombre_autopercibido && (
                           <span className={styleTattoo.error}>
                              {errors.nombre_autopercibido}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>Pronombres *</label>
                     <select
                        name="pronombres"
                        value={input.pronombres}
                        onChange={handleChange}
                        className={styleTattoo.input}
                     >
                        <option value="ella">ella</option>
                        <option value="el">él</option>
                        <option value="elle">elle</option>
                        <option value="otro">Otro</option>
                     </select>
                     {input.pronombres === "otro" && (
                        <input
                           type="text"
                           name="otro_pronombre"
                           value={input.otro_pronombre}
                           onChange={handleChange}
                           className={styleTattoo.input}
                           placeholder="Especifique"
                           style={{ marginTop: "8px" }}
                        />
                     )}
                  </div> */}

                  <div className={styleTattoo.inputRow}>
                     <div className={styleTattoo.inputGroup}>
                        <label className={styleTattoo.label}>
                           Fecha de hoy *
                           <input
                              type="date"
                              name="fechaHoy"
                              value={input.fechaHoy}
                              onChange={handleChange}
                              className={styleTattoo.input}
                           />
                        </label>
                     </div>

                     <div className={styleTattoo.inputGroup}>
                        <label className={styleTattoo.label}>
                           Fecha del turno *
                           <input
                              type="date"
                              name="fechaTurno"
                              value={input.fechaTurno}
                              onChange={handleChange}
                              className={`${styleTattoo.input} ${
                                 errors.fechaTurno ? styleTattoo.inputError : ""
                              }`}
                           />
                           {errors.fechaTurno && (
                              <span className={styleTattoo.error}>
                                 {errors.fechaTurno}
                              </span>
                           )}
                        </label>
                     </div>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        Nombre y Apellido (como figura en el DNI) *
                        <input
                           type="text"
                           name="apellido"
                           value={input.apellido}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.apellido ? styleTattoo.inputError : ""
                           }`}
                           placeholder="Ingrese apellido"
                        />
                        {errors.apellido && (
                           <span className={styleTattoo.error}>
                              {errors.apellido}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        DNI *
                        <input
                           type="text"
                           name="dni"
                           value={input.dni}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.dni ? styleTattoo.inputError : ""
                           }`}
                           placeholder="Ingrese DNI"
                        />
                        {errors.dni && (
                           <span className={styleTattoo.error}>
                              {errors.dni}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        Teléfono *
                        <input
                           type="tel"
                           name="telefono"
                           value={input.telefono}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.telefono ? styleTattoo.inputError : ""
                           }`}
                           placeholder="Ingrese teléfono"
                        />
                        {errors.telefono && (
                           <span className={styleTattoo.error}>
                              {errors.telefono}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        Teléfono de contacto familiar (en caso de urgencia) *
                        <input
                           type="tel"
                           name="telefono_familiar"
                           value={input.telefono_familiar}
                           onChange={handleChange}
                           className={`${styleTattoo.input} ${
                              errors.telefono_familiar
                                 ? styleTattoo.inputError
                                 : ""
                           }`}
                           placeholder="Ingrese teléfono familiar"
                        />
                        {errors.telefono_familiar && (
                           <span className={styleTattoo.error}>
                              {errors.telefono_familiar}
                           </span>
                        )}
                     </label>
                  </div>

                  <div className={styleTattoo.inputRow}>
                     <div className={styleTattoo.inputGroup}>
                        <label className={styleTattoo.label}>
                           FECHA DE NACIMIENTO: *
                           <input
                              type="date"
                              name="fecha_nacimiento"
                              value={input.fecha_nacimiento}
                              onChange={handleFechaNacimientoChange}
                              className={`${styleTattoo.input} ${
                                 errors.fechaNacimiento
                                    ? styleTattoo.inputError
                                    : ""
                              }`}
                           />
                           {errors.fechaNacimiento && (
                              <span className={styleTattoo.error}>
                                 {errors.fechaNacimiento}
                              </span>
                           )}
                        </label>
                     </div>

                     <div className={styleTattoo.inputGroup}>
                        <label className={styleTattoo.label}>
                           EDAD: *
                           <input
                              type="number"
                              name="edad"
                              value={input.edad}
                              onChange={handleChange}
                              className={`${styleTattoo.input} ${
                                 errors.edad ? styleTattoo.inputError : ""
                              }`}
                              placeholder="Edad"
                              readOnly
                           />
                           {errors.edad && (
                              <span className={styleTattoo.error}>
                                 {errors.edad}
                              </span>
                           )}
                        </label>
                     </div>
                  </div>

               </section>
                     {/* ✅ Sección para menores de 18 años */}

                     {parseInt(input.edad) < 18 && (
                        <>
                           <div className={styleTattoo.inputGroup} style={{ marginTop: "24px" }}>
                              <label className={styleTattoo.label}>
                                 NOMBRE DEL TUTOR/PADRE/MADRE: *
                                 <input
                                    type="text"
                                    name="nombreTutor"
                                    value={input.nombreTutor}
                                    onChange={handleChange}
                                    className={`${styleTattoo.input} ${
                                       errors.nombreTutor ? styleTattoo.inputError : ""
                                    }`}
                                    placeholder="Ingrese nombre completo del tutor"
                                 />
                                 {errors.nombreTutor && (
                                    <span className={styleTattoo.error}>
                                       {errors.nombreTutor}
                                    </span>
                                 )}
                              </label>
                           </div>

                           <div style={{ margin: "16px 0" }}>
                              <label className={styleTattoo.question}>Firma del Tutor *</label>
                              {firmaTutorPreview ? (
                                 <div style={{ margin: "16px 0" }}>
                                    <img
                                       src={firmaTutorPreview}
                                       alt="Firma tutor"
                                       style={{
                                          maxWidth: "300px",
                                          maxHeight: "120px",
                                          border: "1px solid #ccc",
                                          borderRadius: "8px",
                                       }}
                                    />
                                 </div>
                              ) : (
                                 <>
                                    <SignaturePad
                                       canvasProps={{
                                          width: 635,
                                          height: 240,
                                          style: {
                                             border: "1px solid #aeaeaeff",
                                             borderRadius: "8px",
                                          },
                                       }}
                                       ref={tutorSignaturePadRef}
                                    />
                                    <button
                                       type="button"
                                       style={{ marginTop: "8px" }}
                                       onClick={() => tutorSignaturePadRef.current.clear()}
                                    >
                                       Limpiar Firma del Tutor
                                    </button>
                                 </>
                              )}
                              {errors.firmaTutor && (
                                 <span className={styleTattoo.error}>
                                    {errors.firmaTutor}
                                 </span>
                              )}
                           </div>
                        </>
                     )}

               {/* ANTECEDENTES MÉDICOS */}
               <section className={styleTattoo.section}>
                  <h2 className={styleTattoo.sectionTitle}>
                     ANTECEDENTES MÉDICOS
                  </h2>

                  <div className={styleTattoo.questionGroup}>
                     <label className={styleTattoo.question}>
                        ¿Tiene antecedentes personales o familiares de melanomas?
                        *
                        <select
                           name="antecedentes_melanoma"
                           value={input.antecedentes_melanoma}
                           onChange={handleChange}
                           className={styleTattoo.input}
                        >
                           <option value="No">No</option>
                           <option value="Si, Personales">Sí, Personales</option>
                           <option value="Si, Familiares">Sí, Familiares</option>
                           <option value="No sé">No sé</option>
                        </select>
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className={styleTattoo.question}>
                        ¿Posee alguna de las siguientes afecciones? *
                     </label>
                     {[
                        "Diabetes",
                        "Trastornos de coagulación",
                        "Anemia",
                        "Hemofilia",
                        "Cardiopatías",
                        "Cicatrización queloide",
                        "Lupus",
                        "Artritis reumatoides",
                        "Epilepsia",
                        "Vitiligo",
                        "Dermatitis atópica o eccema atópico",
                        "Liquen plano",
                        "Angiomas",
                        "Psoriasis",
                        "Presión Baja",
                        "Síndrome de nevo atípico",
                        "Ninguna",
                     ].map((afeccion) => (
                        <div key={afeccion} style={{ marginBottom: "8px" }}>
                           <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <input
                                 type="checkbox"
                                 checked={input.afecciones.includes(afeccion)}
                                 onChange={() =>
                                    handleMultiSelect("afecciones", afeccion)
                                 }
                              />
                              {afeccion}
                           </label>
                        </div>
                     ))}
                     <input
                        type="text"
                        name="otra_afeccion"
                        value={input.otra_afeccion}
                        onChange={handleChange}
                        className={styleTattoo.input}
                        placeholder="Otra (especifique)"
                        style={{ marginTop: "8px" }}
                     />
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className={styleTattoo.question}>
                        ¿Posee alguna de las siguientes afecciones en la zona a
                        tatuar? *
                     </label>
                     {[
                        "Várices",
                        "Verrugas",
                        "Lunares",
                        "Hematomas",
                        "Úlceras",
                        "Quemaduras recientes",
                        "Lastimaduras o raspón",
                        "Cicatrices inestables",
                        "Ninguna",
                     ].map((afeccion) => (
                        <div key={afeccion} style={{ marginBottom: "8px" }}>
                           <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <input
                                 type="checkbox"
                                 checked={input.afecciones_zona.includes(
                                    afeccion
                                 )}
                                 onChange={() =>
                                    handleMultiSelect("afecciones_zona", afeccion)
                                 }
                              />
                              {afeccion}
                           </label>
                        </div>
                     ))}
                     <input
                        type="text"
                        name="otra_afeccion_zona"
                        value={input.otra_afeccion_zona}
                        onChange={handleChange}
                        className={styleTattoo.input}
                        placeholder="Otra (especifique)"
                        style={{ marginTop: "8px" }}
                     />
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className={styleTattoo.question}>
                        ¿Posee lunares en la zona a tatuar? *
                        <select
                           name="lunares_zona"
                           value={input.lunares_zona}
                           onChange={handleChange}
                           className={styleTattoo.input}
                        >
                           <option value="No">No</option>
                           <option value="Sí">Sí</option>
                        </select>
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className={styleTattoo.question}>
                        ¿Tienes alergia al látex? *
                        <select
                           name="alergia_latex"
                           value={input.alergia_latex}
                           onChange={handleChange}
                           className={styleTattoo.input}
                        >
                           <option value="No">No</option>
                           <option value="Sí">Sí</option>
                           <option value="No sé">No sé</option>
                        </select>
                     </label>
                  </div>

                  <div className={styleTattoo.questionGroup}>
                     <label className={styleTattoo.question}>
                        ¿Se encuentra bajo tratamiento con alguno de estos
                        fármacos? *
                     </label>
                     {[
                        "Ibuprofeno, Aspirina, Aspirineta, y/o Diclofenac (automedicados)",
                        "Ibuprofeno, Aspirina, Aspirineta y/o Diclofenac (recetados por mi médicx)",
                        "anticoagulantes",
                        "antiagregantes plaquetarios",
                        "inmunosupresores",
                        "antiepilépticos",
                        "corticoides",
                        "Isotretinoína (Roacutan)",
                        "ninguno",
                     ].map((farmaco) => (
                        <div key={farmaco} style={{ marginBottom: "8px" }}>
                           <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <input
                                 type="checkbox"
                                 checked={input.tratamientoFarmacos.includes(
                                    farmaco
                                 )}
                                 onChange={() =>
                                    handleMultiSelect(
                                       "tratamientoFarmacos",
                                       farmaco
                                    )
                                 }
                              />
                              {farmaco}
                           </label>
                        </div>
                     ))}
                     <input
                        type="text"
                        name="otro_farmaco"
                        value={input.otro_farmaco}
                        onChange={handleChange}
                        className={styleTattoo.input}
                        placeholder="Otro (especifique)"
                        style={{ marginTop: "8px" }}
                     />
                  </div>

                  {/* Preguntas Sí/No */}
                  {[
                     {
                        name: "quimioterapiaReciente",
                        label:
                           "¿Se ha realizado quimioterapia o radioterapia recientemente?",
                     },
                     {
                        name: "quimioterapiaProxima",
                        label:
                           "¿Se debe realizar quimioterapia o radioterapia próximamente?",
                     },
                     {
                        name: "trasplanteOrganos",
                        label: "¿Ha recibido un trasplante de órganos?",
                     },
                     {
                        name: "valvulaCardiaca",
                        label: "¿Tiene válvula artificial cardíaca?",
                     },
                     {
                        name: "operacionReciente",
                        label: "¿Tuvo alguna operación muy reciente?",
                     },
                     {
                        name: "infeccionActual",
                        label: "¿Posee en este momento alguna infección?",
                     },
                     {
                        name: "alergiaParticular",
                        label: "¿Posee alguna alergia en particular?",
                     },
                     {
                        name: "alergiaLidocaina",
                        label: "¿Es alérgicx a la lidocaína?",
                     },
                     {
                        name: "embarazo",
                        label: "¿Está cursando un embarazo?",
                     },
                     {
                        name: "lactancia",
                        label: "¿Se encuentra en período de lactancia?",
                     },
                  ].map((pregunta) => (
                     <div
                        key={pregunta.name}
                        className={styleTattoo.questionGroup}
                     >
                        <label className={styleTattoo.question}>
                           {pregunta.label} *
                           <select
                              name={pregunta.name}
                              value={input[pregunta.name]}
                              onChange={handleChange}
                              className={styleTattoo.input}
                           >
                              <option value="No">No</option>
                              <option value="Sí">Sí</option>
                              {pregunta.name === "quimioterapiaProxima" && (
                                 <option value="Tal vez">Tal vez</option>
                              )}
                              {pregunta.name === "embarazo" && (
                                 <option value="Tal vez">Tal vez</option>
                              )}
                           </select>
                        </label>
                     </div>
                  ))}

                  {input.alergiaParticular === "Sí" && (
                     <div className={styleTattoo.inputGroup}>
                        <label className={styleTattoo.label}>
                           Especifique la alergia
                           <textarea
                              name="aclaracionAlergia"
                              value={input.aclaracionAlergia}
                              onChange={handleChange}
                              className={styleTattoo.textarea}
                              rows="3"
                              placeholder="Describa la alergia"
                           />
                        </label>
                     </div>
                  )}
               </section>

               {/* ADVERTENCIAS Y ACEPTACIONES */}
               <section className={styleTattoo.section}>
                  <h2 className={styleTattoo.sectionTitle}>
                     ADVERTENCIAS Y CONSENTIMIENTOS
                  </h2>

                  <div className={styleTattoo.disclaimerText}>
                     <p>
                        <strong>IMPORTANTE:</strong> Si vivís con alguna
                        condición de salud que implique inmunosupresión o
                        déficit inmunológico (por ejemplo, tratamientos
                        prolongados con corticoides, quimioterapia, trasplantes,
                        VIH, otras enfermedades), tené en cuenta que el proceso
                        de cicatrización puede ser más lento o presentar
                        complicaciones. Ante cualquier duda, consultá
                        previamente con un/a profesional de la salud antes de
                        realizarte el procedimiento.
                     </p>
                  </div>

                  <div className={styleTattoo.checkboxGroup}>
                     <label className={styleTattoo.checkboxLabel}>
                        <input
                           type="checkbox"
                           name="comprendoInmunosupresion"
                           checked={input.comprendoInmunosupresion}
                           onChange={handleChange}
                           className={styleTattoo.checkbox}
                        />
                        Sí, comprendo *
                     </label>
                     {errors.comprendoInmunosupresion && (
                        <span className={styleTattoo.error}>
                           {errors.comprendoInmunosupresion}
                        </span>
                     )}
                  </div>

                  <div className={styleTattoo.disclaimerText}>
                     <p>
                        Si usted consume alcohol en las 24 hs previas al turno,
                        no podrá realizarse el tatuaje ya que puede ocasionar
                        sangrado excesivo. Lo mismo, si ha consumido algún tipo
                        de estupefaciente. Procure asistir habiendo realizado
                        todas las comidas del día.
                     </p>
                  </div>

                  <div className={styleTattoo.checkboxGroup}>
                     <label className={styleTattoo.checkboxLabel}>
                        <input
                           type="checkbox"
                           name="aceptoAlcoholEstupefacientes"
                           checked={input.aceptoAlcoholEstupefacientes}
                           onChange={handleChange}
                           className={styleTattoo.checkbox}
                        />
                        Sí, acepto *
                     </label>
                     {errors.aceptoAlcoholEstupefacientes && (
                        <span className={styleTattoo.error}>
                           {errors.aceptoAlcoholEstupefacientes}
                        </span>
                     )}
                  </div>

                  <div className={styleTattoo.checkboxGroup}>
                     <label className={styleTattoo.checkboxLabel}>
                        <input
                           type="checkbox"
                           name="comprendoInfecciones"
                           checked={input.comprendoInfecciones}
                           onChange={handleChange}
                           className={styleTattoo.checkbox}
                        />
                        Comprendo que un tatuaje es una herida y puede sufrir la
                        evolución de infecciones, irritaciones, inflamaciones u
                        otras dolencias causadas por diversos motivos *
                     </label>
                     {errors.comprendoInfecciones && (
                        <span className={styleTattoo.error}>
                           {errors.comprendoInfecciones}
                        </span>
                     )}
                  </div>

                  <div className={styleTattoo.checkboxGroup}>
                     <label className={styleTattoo.checkboxLabel}>
                        <input
                           type="checkbox"
                           name="acepto_alergia"
                           checked={input.acepto_alergia}
                           onChange={handleChange}
                           className={styleTattoo.checkbox}
                        />
                        Entiendo y acepto que la realización de un tatuaje puede
                        desarrollar una alergia a alguno de los materiales
                        utilizados *
                     </label>
                     {errors.acepto_alergia && (
                        <span className={styleTattoo.error}>
                           {errors.acepto_alergia}
                        </span>
                     )}
                  </div>

                  <div className={styleTattoo.checkboxGroup}>
                     <label className={styleTattoo.checkboxLabel}>
                        <input
                           type="checkbox"
                           name="acepto_apto"
                           checked={input.acepto_apto}
                           onChange={handleChange}
                           className={styleTattoo.checkbox}
                        />
                        En algunos casos, según la zona del cuerpo a tatuar o las
                        condiciones particulares de salud de la persona, se podrá
                        solicitar un certificado de apto médico *
                     </label>
                     {errors.acepto_apto && (
                        <span className={styleTattoo.error}>
                           {errors.acepto_apto}
                        </span>
                     )}
                  </div>

                  <div className={styleTattoo.inputGroup}>
                     <label className={styleTattoo.label}>
                        Aclaraciones generales
                        <textarea
                           name="aclaracionesGenerales"
                           value={input.aclaracionesGenerales}
                           onChange={handleChange}
                           className={styleTattoo.textarea}
                           rows="4"
                           placeholder="Utilice este campo para realizar cualquier aclaración que considere pertinente"
                        />
                     </label>
                  </div>
               </section>

               {/* FIRMA */}
               <section className={styleTattoo.section}>
                  <h2 className={styleTattoo.sectionTitle}>FIRMA</h2>

                  <div className={styleTattoo.checkboxGroup}>
                     <label className={styleTattoo.checkboxLabel}>
                        <input
                           type="checkbox"
                           name="firmado"
                           checked={input.firmado}
                           onChange={handleChange}
                           className={styleTattoo.checkbox}
                        />
                        Acepto el consentimiento informado y confirmo que toda la
                        información proporcionada es veraz *
                     </label>
                     {errors.firmado && (
                        <span className={styleTattoo.error}>
                           {errors.firmado}
                        </span>
                     )}
                  </div>

                  {firmaClientePreview ? (
                     <div style={{ margin: "16px 0" }}>
                        <img
                           src={firmaClientePreview}
                           alt="Firma cliente"
                           style={{
                              maxWidth: "300px",
                              maxHeight: "120px",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                           }}
                        />
                     </div>
                  ) : (
                     <div style={{ margin: "16px 0" }}>
                        <label className={styleTattoo.question}>
                           Firma Digital
                        </label>
                        <SignaturePad
                           canvasProps={{
                              width: 635,
                              height: 240,
                              style: {
                                 border: "1px solid #aeaeaeff",
                                 borderRadius: "8px",
                              },
                           }}
                           ref={clienteSignaturePadRef}
                        />
                        <button
                           type="button"
                           style={{ marginTop: "8px" }}
                           onClick={() => clienteSignaturePadRef.current.clear()}
                        >
                           Limpiar Firma
                        </button>
                     </div>
                  )}
               </section>

               {/* Botones */}
               <div className={styleTattoo.buttonGroup}>
                  <button
                     type="button"
                     onClick={() => navigate(-1)}
                     className={styleTattoo.cancelButton}
                     disabled={isSubmitting}
                  >
                     Cancelar
                  </button>
                  <button
                     type="submit"
                     className={styleTattoo.submitButton}
                     disabled={isSubmitting}
                  >
                     {isSubmitting
                        ? "Guardando..."
                        : "Guardar Consentimiento"}
                  </button>
               </div>
            </form>
         </div>
      </div>
   );
};

export default ContratoTattooExtendido;